<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title class="easter-egg-title">Bzz Bzz</h2>

<mat-dialog-content class="easter-egg-content">
  <span class="bee-icon" aria-hidden="true">🐝</span>
  <p class="mb-3 easter-egg-message">Realizzata con amore per lavoratori instancabili!</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Sulla fascia panna: il petrol pieno bordato nero, l'unica azione del
       dialog. -->
  <button
    mat-raised-button
    matButton="filled"
    mat-dialog-close
    class="izy-button-primary custom-button-border">
    Ok!
  </button>
</mat-dialog-actions>
